module.exports = __webpack_public_path__ + "img/icon-sale-select.54c8381b.png";